// one more values in backend: fetus not mother
export const PROP = [
  { key: 1, value: 'your child', text: 'My child' },
  { key: 2, value: 'yourself', text: 'Myself' },
  { key: 3, value: 'your fetus', text: 'Fetus' },
  { key: 4, value: 'other relative', text: 'Someone else' }
];
export const getText = (value) => {
  if (value === 'fetus not mother') {
    value = 'your fetus';
  }
  if (value === 'other not relative') {
    value = 'other relative';
  }
  if (
    value === undefined ||
    !(value === 'yourself' || value === 'your fetus' || value === 'your child')
  ) {
    value = 'yourself';
  }

  var text = PROP.find((obj) => {
    return obj !== undefined && obj.value === value;
  }).text;
  return text;
};
